import { AuthActionTypes, SET_TOKEN } from './authActions'

export type Token = string | null
export interface AuthState {
    token: Token
}

export const initialAuthState: AuthState = {
    token: null
}

export const authReducer = (state: AuthState = initialAuthState, action: AuthActionTypes): AuthState => {

    switch (action.type) {
        case SET_TOKEN: {
            return {
                token: action.token
            }
        }
        default:
            return state
    }
}